import React, {useState, useEffect, useRef} from "react"
import PropTypes from "prop-types"
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
  Row,
  Col, Input, Alert,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container, Card, CardBody, CardTitle, CardText
} from "reactstrap"
import Select from "react-select"
import axios from "axios"
import * as url from "../../helpers/url_helper"
import * as be from 'helpers/backend_helper';
import { Config, TOAST_OPTIONS, formatDate, getContentTypeFromBase64 } from "../../helpers/backend_helper"
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { Link, useHistory, useParams } from "react-router-dom"
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
import BounceLoader from 'react-spinners/BounceLoader'
import MetaTags from 'react-meta-tags'; 
import { MapContainer, TileLayer, Marker, Tooltip, Polyline, LayersControl } from 'react-leaflet';
import rd from "assets/icons/pin2.png";
import L from "leaflet"

const AddComplaint = () => {
    const history = useHistory();
    toastr.options = TOAST_OPTIONS;


    const [isEdit, setIsEdit] = useState(false);
    const [complaints, setComplaints] = useState([])
    const [categories, setCategories] = useState([])

    const [id, setId] = useState('')
    const [refno, setRefNo] = useState('')
    const [name, setName] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')
    const [account, setAccount] = useState('')
    const [address, setAddress] = useState('')
    const [area, setArea] = useState('')
    const [category, setCategory] = useState('')
    const [details, setDetails] = useState('')
    const [status, setStatus] = useState('')
    const [handlerDept, setHandlerDept] = useState('')
    const [assigns, setAssigns] = useState([])
    const [deptList, setDeptList] = useState([])
    const [handler, setHandler] = useState('')
    const [dateTimeAssigned, setDateTimeAssigned] = useState('')
    const [dateTimeRegistered, setDateTimeRegistered] = useState('')
    const [languages, setlanguages] = useState([])
    const [lang, setLang] = useState('Somali')
    const [areas, setAreas] = useState([])

    const [userId, setUserId]       = useState('')
    const [userName, setUserName]   = useState('')
    const [selectedFile, setSelectedFile] = useState([])

    const [logs, setLogs] = useState([])

    const [zoom, setZoom] = useState(4)
    const [center, setCenter] = useState([9.426039, 46.270828])
    const mapRef = useRef(null);
    const [lat, setLat] = useState(null);
    const [lng, setLng] = useState(null);
    const [routeCoordinates, setRouteCoordinates] = useState([]);
    const [distance, setDistance] = useState('Location')

    const [isLoading, setIsLoading] = useState(false)
    const [general, setGeneral] = useState(true)

    const fetchRoute = async (latlon) => {
      try {
        const apiKey = process.env.REACT_APP_APIKEY;
        const start = '44.051146,9.560198'; 
        const end = latlon; 
        const urx = `https://api.mapbox.com/directions/v5/mapbox/driving/${start};${end}?alternatives=true&continue_straight=true&geometries=polyline&language=en&overview=full&steps=true&access_token=${apiKey}`;
        let rt = []
        const response = await axios.get(urx);
        const coordinates = response.data.routes[0].geometry.coordinates;
        if(response.data.routes.length > 0){
          setDistance(response.data.routes[0].legs[0].summary +" - "+((response.data.routes[0].legs[0].distance)/1000).toFixed(1) + "km")
          response.data.routes[0].legs[0].steps.map((a)=>{
            if(a.intersections.length > 0){
              a.intersections.map((i)=>{
                rt.push([i.location[1],i.location[0]])
              })
            }
          })
        }
        setRouteCoordinates(rt);
      } catch (error) {
        console.error('Error fetching route:', error);
      }
    };
    const redPoint = L.icon({
      iconUrl:rd,
      iconSize: [26, 51], 
      iconAnchor: [14, 80], 
      popupAnchor: [-3, -76] 
    })
    const setLetter = (a) =>{
      const areaName = areas.find(item => item.id === a).name
      setAccount((areaName.match(/\((.*?)\)/) || [])[1] + "-")
    }
    const fetchData = () => {
        axios.get(url.COMPLAINTCATEGORIES, Config).then((r)=>{ 
          setCategories(r.data)
        }).catch((e)=>{  
          console.log(e)
        });
        axios.get(`${url.USERS}`, Config).then((r)=>{ 
          setAssigns(r.data)
        }).catch((e)=>{  
          console.log(e);
        });
        axios.get(`${url.TERRITORIES}`, Config).then((r)=>{ 
          setAreas(r.data);
        }).catch((e)=>{  
          console.log(e);
        });
        axios.get(`${url.MESSAGES}`, Config).then((r)=>{
          setlanguages(r.data)
        }).catch((e)=>{
          console.log(e)
        })
        axios.get(url.DEPTS, Config).then((r)=>{ setDeptList(r.data)}).catch((e)=>console.log(e))
        const obj = JSON.parse(localStorage.getItem("authWTUser"));
        setUserId(obj.id)
        setUserName(obj.username)
        setLogs([{"activity": "Registering", "dateTime": formatDate(new Date), "user": obj.username}])

      }
      const handleCheckAcc = () => {
        
        const data = { supplyNo: account }; 
        axios.post(url.GIS, JSON.stringify(data))
          .then((response) => {
            const { data } = response;
            if (data.latitude) {
              const lati = parseFloat(data.longitude)
              const long = parseFloat(data.latitude)
              zoomIn();
              setLat(lati);
              setLng(long);
              setMapCenterAnimated(lati, long);
              fetchRoute(long+','+lati)
            } else {
              zoomOut();
              setLat(null);
              setLng(null);
              setMapCenterAnimated(9.426039, 46.270828);
              toastr.info('Supply number has no GIS data')
            }
          })
          .catch((error) => {
            console.error('Error fetching data:', error);
          });
          
      };
      const zoomIn = () => {
        if (mapRef.current) {
          const map = mapRef.current; 
          const currentZoom = map.getZoom(); 
          map.setZoom(16); 
        }
      };
    
      const zoomOut = () => {
        if (mapRef.current) {
          const map = mapRef.current; 
          const currentZoom = map.getZoom(); 
          map.setZoom(5); 
        }
      };

      const setMapCenterAnimated = (lat, lng) => {
        setCenter([lat, lng]); 
        if (mapRef.current) {
          mapRef.current.flyTo([lat, lng], mapRef.current.getZoom(), {
            duration: 5, 
            animate: true 
          });
        }
      };
      useEffect(() => {
        fetchData();
      },[]);

      const handleAddComplaint = () =>{
        if(name.trim().length < 3){
          toastr.error("Enter complainant's name")
        }else if((phone.trim().length < 10) ){
          toastr.error("Enter valid complainant's phone number")
        }else if(!be.fno(phone)){
          toastr.error("Enter valid complainant's phone number in format +252631234567")
        }else if(address.trim().length < 5){
          toastr.error("Enter complainant's address")
        }else if(lang.length < 3){
          toastr.error("Specify communication language")
        }else if(category.trim() == ""){
          toastr.error("Specify complaint category")
        }else{
          const obj = JSON.parse(localStorage.getItem("authWTUser"));

          const  data = {
              name    : name,
              phone   : phone,
              email   : email,
              account : account.toUpperCase().replace(/\s+/g, ''),
              address : address,
              area    : area,
              type    : category,
              message : details,
              lang    : lang,
              userId  : obj.id,
              action  : "add"
            }
          setIsLoading(true)
          axios.post(url.COMPLAINTS, JSON.stringify(data), Config).then((r)=>{
            
            if(r.data.status == '1'){
              history.push("Customer-Complaints/")
              if(selectedFile.length > 0){
                selectedFile.forEach((f)=>{
                  const reader = new FileReader();
                  reader.readAsDataURL(f);
                  reader.onloadend = () => {
                      const base64Data = reader.result;
                      const fileName = f.name;
                      const fileExtension = fileName.split('.').pop();
                      const fileData = {
                          action:"add",
                          cId: r.data.id,
                          FileName:fileName,
                          FileExtension: fileExtension,
                          fileContentType:getContentTypeFromBase64(base64Data),
                          FileContentsBase64:base64Data.split(',')[1]
                      }
  
                      setIsLoading(true)
                      axios.post(url.ATTACHDOCUMENT, JSON.stringify(fileData), Config).then((rf)=>{
                        toastr.success(rf.data.message)
                        //history.push("Customer-Complaints/")
                      }).catch((ef)=>{ 
                          console.log(ef)
                          setIsLoading(false)
                      })
                      
                  }
                })
              }else{
                toastr.success(r.data.message)
              }
            }else{
              toastr.error(r.data.message)
            }
            setIsLoading(false)
          }).catch((e)=>{
            console.log(e)
            setIsLoading(false)
          })
        
        }
        
      }

   
    return (
        <>
        <LoadingOverlay
            active={isLoading}
            spinner={<BounceLoader />}
            text='Please wait...' >
            <div className="page-content">
                <MetaTags>
                <title>Customer Complaints | {url.COMPANY}</title>
                </MetaTags>
                <Container fluid={true}>

                               

                    <div>
                        <Row>
                        <Col  xl={9}>
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Register Customer Complaint</h5>
                                
                                <CardBody>

                             
                                    <Row>
                                        
                                    <Col md={4}>
                                            <div className="mb-3">
                                                <label>{`Complainant's Name`}</label>
                                                <input type='text' className="form-control" value={name} onChange={(e)=>setName(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="mb-3">
                                                <label>Email</label>
                                                <input type='email' className="form-control" value={email} onChange={(e)=>setEmail(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="mb-3">
                                                <label>Phone number </label>
                                                <input type='text' className="form-control" value={phone} placeholder='+252637951277' onChange={(e)=>setPhone(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="mb-3">
                                                <label>District</label>
                                                <select className="form-select" value={area} onChange={(e)=>{setArea(e.target.value); setLetter(e.target.value)}}>
                                                <option value=""></option>
                                                    {areas.map((c,k)=>(
                                                        <option value={c.id} key={k}>{c.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="mb-3">
                                                <label>Address</label>
                                                <input type='text' className="form-control" value={address} onChange={(e)=>setAddress(e.target.value)}/>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="mb-3">
                                                <label>Supply No</label>
                                                <input type='text' className="form-control" value={account} onChange={(e)=>{setAccount(e.target.value); handleCheckAcc(e.target.value)}}/>
                                            </div>
                                        </Col>
                                        
                                        
                                        <Col md={4}>
                                            <div className="mb-3">
                                                <label>Language</label>
                                                <select className="form-select" value={lang} onChange={(e)=>setLang(e.target.value)}>
                                                      <option value=""></option>
                                                    {languages.map((c,k)=>(
                                                        <option value={c.lang} key={k}>{c.lang}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={8}>
                                            <div className="mb-3">
                                                <label>Complaint Type/category</label>
                                                <select className="form-select" value={category} onChange={(e)=>setCategory(e.target.value)}>
                                                    <option value=""></option>
                                                    {categories.map((c,k)=>(
                                                        <option value={c.id} key={k}>{c.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Col>
                                        
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Complaint Details</label>
                                                <textarea className="form-control" rows={10} value={details} onChange={(e)=>setDetails(e.target.value)}></textarea>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Attach files</label>
                                                <input type="file" multiple className="form-control"  onChange={(e)=>setSelectedFile(Array.from(e.target.files))}   />
                                            </div>
                                        </Col>
                                    </Row>
                                   
                                    

                        
                                    <Row>
                                    <Col>
                                        <div className="modal-footer justify-content-center">
<button type="button" className="btn btn-success" onClick={handleAddComplaint}>Save customer complaint details...</button>

                                  </div>
                                        </Col>
                                    </Row>
                                    </CardBody>
                            </Card>
                            </Col>
                            <Col xl={3}>
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">{distance}</h5>
                 
                                            <MapContainer center={center} zoom={4} ref={mapRef} style={{ height: '400px', width: '100%' }}>
                                              
                                                <LayersControl position="topright">
                                                <LayersControl.BaseLayer name="Satellite">
                                                  <TileLayer
                                                    attribution='&copy; <a href="https://www.mapbox.com/">Mapbox</a>'
                                                    url="https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}"
                                                    id="mapbox/satellite-v9" 
                                                    accessToken={process.env.REACT_APP_APIKEY}
                                                  />
                                                </LayersControl.BaseLayer>
                                                <LayersControl.BaseLayer checked name="Street">
                                                  <TileLayer
                                                      attribution='&copy; <a href="https://www.mapbox.com/">Mapbox</a>'
                                                      url="https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}"
                                                      id="mapbox/streets-v11" 
                                                      accessToken={process.env.REACT_APP_APIKEY}
                                                    />
                                                </LayersControl.BaseLayer>
                                              </LayersControl>
                                              {lat && lng && <Marker position={[lat, lng]} icon={redPoint}><Tooltip><strong>{account}</strong><br/>{lat}<br/>{lng}</Tooltip></Marker>}
                                              <Polyline pathOptions={{ color: 'red' }} positions={routeCoordinates} />
                                            </MapContainer>
                                          
                                </Card>
                                <Card>
                                <h5 className="card-header bg-transparent border-bottom text-uppercase">LOGS</h5>
                                 <CardBody>
                                        <Row>
                                            <Col md={12}>
                                            <div>
                                                <ul className="verti-timeline list-unstyled">
                                                {logs.map((l,k)=>(
                                                    <li key={k} className="event-list">
                                                    <div className="event-timeline-dot">
                                                        <i className="bx bx-right-arrow-circle" />
                                                    </div>
                                                    <div className="d-flex">
                                                        <div className="me-3">
                                                        <i className="bx bx-copy-alt h2 text-primary" />
                                                        </div>
                                                        <div className="flex-grow-1">
                                                        <div>
                                                            <h5 className="font-size-14">{l.activity}</h5>
                                                            <p className="text-muted">
                                                            {l.dateTime}<br/>{l.user}
                                                            </p>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </li>
                                                ))}
                        
                                                </ul>
                                                </div>
                                            </Col>
                                        </Row>
                                        </CardBody>
                                </Card>
                            </Col>
                           
                        </Row>
                    </div>
                </Container>  
            </div>
            </LoadingOverlay>
        </>
    );
}

export default AddComplaint;